<template>
  <DialogLayout
    title="詳細情報"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
    class="edit-dialog"
  >
    <template #form>
      <MergeDataForm
        ref="mergeDataForm"
        v-model="mergeDataFormModel"
        label-width="10em"
        formMode="edit"
        :editDisabledMode="editDisabledMode"
        :autocomplete-registration-symbol-set="autocompleteRegistrationSymbolSet"
        :autocomplete-model-code-set="autocompleteModelCodeSet"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
        :autocomplete-airport-code-set="autocompleteAirportCodeSet"
      />
    </template>
    <template v-if='!editDisabledMode' #footer>
      <EditDialogFooter
        @update="clickUpdate"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import MergeDataForm from '@/components/organisms/dialog/data/MergeDataForm.vue'
import EditDialogFooter from '@/components/organisms/dialog/EditDialogFooter.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'
import RegistrationSymbolAutocompleteLoader from '@/mixins/RegistrationSymbolAutocompleteLoader.vue'
import AirportAutocompleteLoader from '@/mixins/AirportAutocompleteLoader.vue'

export default {
  components: {
    DialogLayout,
    MergeDataForm,
    EditDialogFooter
  },
  mixins: [
    CustomerAutocompleteLoader,
    RegistrationSymbolAutocompleteLoader,
    AirportAutocompleteLoader
  ],
  props: {
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      mergeDataFormModel: {
        billing_ym: undefined,
        registration_symbol: undefined,
        action_type: undefined,
        action_time: undefined,
        model_code: undefined,
        aircraft_type: undefined,
        weight: undefined,
        noise_level: undefined,
        callsign: undefined,
        route_code: undefined,
        operator_code: undefined,
        bill_to_code: undefined,
        departure_airport_code: undefined,
        destination_airport_code: undefined,
        flight_purpose_code: undefined,
        flight_type: undefined,
        irregular: undefined,
        use_data_status: undefined,
        regist_type: undefined,
        billing_exclusion_flag: undefined,
        updated_on: undefined
      }

    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    },
    editDisabledMode: {
      get () {
        return parseInt(this.mergeDataFormModel.billing_ym) < parseInt(this.getDefaultBillingYm())
      }
    }
  },
  methods: {
    async clickUpdate () {
      this.$loadingMask.on()
      this.$refs.mergeDataForm.validate()
        .then((valid) => {
          return this.$axios.put('/merge-data', this.mergeDataFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.$emit('refresh', this.mergeDataFormModel.billing_ym)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['registration_symbol', 'model_code', 'operator_code', 'bill_to_code', 'departure_airport_code', 'destination_airport_code', 'irregular']
      this.$nextTick(() => {
        this.$refs.mergeDataForm.clearFields()
        Object.keys(this.mergeDataFormModel)
          .forEach((x) => {
            if (trimItem.includes(x)) {
              try {
                this.currentRow[x] = this.currentRow[x].trimEnd()
              } catch (e) {}
            }
            this.$set(this.mergeDataFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
